import React from 'react';
import PropTypes from 'prop-types';
import { Input, InputNumber, Icon } from 'antd';
import Enums from 'utils/EnumsManager';
import { AutoConvertedDatePicker } from 'components/ui/index';

const {
  DateOnly,
  DateTime,
  Email,
  LongText,
  Lookup,
  NumberInput,
  PickList,
  TextInput,
} = Enums.FieldTypes;
const { UserInput } = Enums.WorkFlow;

const defaultProps = {
  handleAddonClick: null,
  handleValueChange: null,
  functionType: null
};
const propTypes = {
  type: PropTypes.oneOf(Enums.FieldTypesInArray).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]).isRequired,
  functionType: PropTypes.string,
  handleAddonClick: PropTypes.func,
  handleValueChange: PropTypes.func,
};

const ValueCriteriaField = ({
  type,
  handleValueChange,
  handleAddonClick,
  value,
  functionType
}) => {
  if (functionType === UserInput && (type === Lookup || type === PickList)) {
    return (
      <Input
        size="small"
        onChange={e => handleValueChange(e.target.value)}
        value={value}
      />
    );
  }

  switch (type) {
    case DateOnly:
    case DateTime:
      return (
        <AutoConvertedDatePicker
          type={type}
          value={value}
          onChange={(date, dateString) => handleValueChange(dateString)}
        />
      );
    case NumberInput:
      return (
        <InputNumber
          className="full-width"
          size="small"
          onChange={num => handleValueChange(num)}
          value={value}
        />
      );
    case PickList:
    case Lookup:
      return (
        <Input
          size="small"
          addonAfter={<Icon type="search" onClick={e => handleAddonClick()} />}
          onChange={e => handleValueChange(e.target.value)}
          value={value}
        />
      );
    case Email:
    case LongText:
    case TextInput:
      return <Input size="small" onChange={e => handleValueChange(e.target.value)} value={value} />;
    default:
      throw Error('No such type in ValueCriteriaField component.');
  }
};

ValueCriteriaField.defaultProps = defaultProps;
ValueCriteriaField.propTypes = propTypes;
export default ValueCriteriaField;



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/components/CommonComponents/ValueColumn.jsx